<template>
  <div
    class="e4Widget__thumbnail__container"
    :style="w > 4 ? 'margin-left: 1%; margin-right: 1%; width: 30%;' : ''"
  >
    <div
      class="e4Widget__thumbnail__container__title"
    >
      <div
        style="width: 10%; max-width: 40px;"
      >
        <v-img
          :src="require(`@/assets/images/widgets/e4/economy-${energy.name}.svg`)"
        />
      </div>
      <div
        style="font-weight: 400; font-size: 1rem; font-weight: 600; margin-left: 10px;"
      >
        {{ $t(`dashboard.e4.titles.${energy.name}`) }}
      </div>
    </div>


    <div
      class="e4Widget__thumbnail__container__paragraph"
    >
      <div
        style="font-weight: 400; font-size: 1.3rem;"
      >
        {{ $t("dashboard.e4.totalReduction") }}
      </div>
    </div>
    <div
      class="e4Widget__thumbnail__container__paragraph"
    >
      <div
        style="font-weight: 400; font-size: 1.3rem;"
        class="e4Widget__thumbnail__container__paragraph__valueSaved"
      >
        <div
          style="width: 50%;"
        >
          {{ calculValueConvered(unit, energy).toLocaleString(locale) }} {{ unit.id || unit }}
        </div>
        <div
          style="width: 50%; height: 40px;"
        >
          <VSelect
            v-model="unit"
            :items="unitsList"
            :label="$t('massBalance.e4Form.labels.unit')"
            dense
            outlined
          />
        </div>
      </div>
    </div>
    <div class="e4Widget__thumbnail__container__economies">
      <div
        class="e4Widget__thumbnail__container__economies__text"
      >
        {{ defineSentence }}
      </div>
      <div
        style="width: 10%;"
      >
        <v-img
          :src="require(`@/assets/images/widgets/e4/logo-${energy.name}.svg`)"
          style="max-width: 40px !important; "
        />
      </div>
    </div>
  </div>
</template>


<script>

import {
    ENERGY_SAVINGS_REPORT_UNITS,
    WATER_SAVING_REPORT_UNITS,
    CO2_EMISSIONS_REPORT_UNITS,
    NB_PER_LITER,
    NB_PER_KG,
    NB_PER_KWH,
} from '@/aquassist-shared/constants/massBalance';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import { mapGetters } from 'vuex';
import _datePickerLocales from '@/locales/date-picker-locales';


export default {
    name: 'Thumbnail',
    components: {
        VSelect,
    },
    props: {
        energy: {
            type: Object,
            required: true,
        },
        w: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            unit: '',
            valueConverted: 0,
        };
    },
    computed: {
        ...mapGetters([
            'lang',
        ]),
        unitsList() {
            if (this.energy.name === 'waterSavings') {
                return WATER_SAVING_REPORT_UNITS.map(value => ({ id: value, name: this.$t(`massBalance.e4Form.units.${value}`) }));
            }
            if (this.energy.name === 'CO2') {
                return CO2_EMISSIONS_REPORT_UNITS.map(value => ({ id: value, name: this.$t(`massBalance.e4Form.units.${value}`) }));
            }
            if (this.energy.name === 'energySavings') {
                return ENERGY_SAVINGS_REPORT_UNITS.map(value => ({ id: value, name: this.$t(`massBalance.e4Form.units.${value}`) }));
            }
            return '';
        },
        defineSentence() {
            if (this.energy.name === 'waterSavings') {
                const waterSavings = Math.round(this.energy.valueSaved / 215).toLocaleString(this.locale);
                return this.$t('dashboard.e4.economiesSentences.waterSavings', { waterSavings });
            }
            if (this.energy.name === 'CO2') {
                const CO2 = Math.round(this.energy.valueSaved / 15).toLocaleString(this.locale);
                return this.$t('dashboard.e4.economiesSentences.CO2', { CO2 });
            }
            if (this.energy.name === 'energySavings') {
                const energySavings = Math.round(this.energy.valueSaved / 3.268).toLocaleString(this.locale);
                return this.$t('dashboard.e4.economiesSentences.energySavings', { energySavings });
            }
            return '';
        },
        locale() {
            return _datePickerLocales[this.lang];
        },

    },
    watch: {
        unit() {
            this.valueConverted = this.energy.valueSaved * this.calculValueConvered(this.unit, this.energy);
        },
        'energy.name': function () {
            this.defineUnitStart();
        },
    },
    mounted() {
        this.defineUnitStart();
        this.calculValueConvered(this.unit, this.energy);
    },
    methods: {
        calculValueConvered(unit, energy) {
            if (energy.name === 'waterSavings') {
                return Math.round(energy.valueSaved * NB_PER_LITER[unit]);
            }
            if (energy.name === 'CO2') {
                return Math.round(energy.valueSaved * NB_PER_KG[unit]);
            }
            if (energy.name === 'energySavings') {
                return Math.round(energy.valueSaved * NB_PER_KWH[unit]);
            }
            return '';
        },
        defineUnitStart() {
            if (this.energy.name === 'waterSavings') {
                this.unit = 'l';
            }
            if (this.energy.name === 'CO2') {
                this.unit = 'kg';
            }
            if (this.energy.name === 'energySavings') {
                this.unit = 'kWh';
            }
            return '';
        },
    },
};
</script>
